import { FormProvider, useForm } from "react-hook-form";

import type { ComponentType, ReactElement } from "react";

export function ScholarshipForm({
  defaultValues,
  Fields,
  Bottom,
  onSubmit,
}: {
  defaultValues: Record<string, unknown>;
  Fields: ReactElement;
  Bottom: ComponentType;
  onSubmit: (values: Record<string, unknown>) => void;
}) {
  const methods = useForm({
    defaultValues,
  });

  return (
    <FormProvider {...methods}>
      <form className="kup-form" onSubmit={methods.handleSubmit(onSubmit)}>
        {Fields}
        <Bottom />
      </form>
    </FormProvider>
  );
}
